<template>
  <div class="formxieyi" v-if="privacyStatement">
    <div class="pagePopMask pFull"></div>
    <div class="pagePop pCenter">
      <div class="w">
        <div class="tit fnt_32 relative">{{ globalDataArray.siteTemplateLanguage.privacy_statement_title || '开放原子大赛获奖队伍相关隐私声明' }}</div>

        <div class="cont txtCont scrollable" ref="scrollDiv" @scroll="handleScroll">
          <div v-if="curInfoArray.competitionTemplateAssociation" class="fnt_20 agreement">
            {{ globalDataArray.siteTemplateLanguage.important_agreement }}
            <span>({{ globalDataArray.siteTemplateLanguage.old_agreemeent_follow }})</span>
          </div>
          <div v-html="compiledMarkdown"></div>
        </div>

        <div class="btnBox fnt_18 btnBox2">
          <a-checkbox :disabled="true" v-if="disabled||!readed" />
          <a-checkbox :checked="checked" @change="onChange" v-else />
          <button class="btn btn1" :title="globalDataArray.siteTemplateLanguage.privacy_statement_has_read" :class="{disabled : counter > 0}" :disabled="counter > 0" @click="agreeFun('1')">{{ globalDataArray.siteTemplateLanguage.btn_has_read }}<span v-if="counter > 0">({{ counter }}s)</span></button>
          <div class="btn btn2" :title="globalDataArray.siteTemplateLanguage.cancel" @click="agreeFun('2')" v-if="!curInfoArray.competitionTemplateAssociation">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="closePop" v-if="!curInfoArray.competitionTemplateAssociation"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { marked } from 'marked'
import { getPrivacyStatement } from '@/api/api'
export default {
  name: 'PrivacyStatement',
  props: {
    privacyStatement: {
      type: Boolean,
      default: false
    },
    curInfoArray: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      counter: 0,
      interval: null,
      checked: false,
      disabled: true,
      content: {},
      readed: false,
      theEnd: true,
      privacyContent: ''
    }
  },
  watch: {
    privacyStatement: {
      immediate: true,
      handler(val) {
        if (val) {
          const that = this
          this.checked = false
          this.readed = false
          this.theEnd = true
          this.disabled = true
          this.counterFun()
          this.getPrivacyContent()
          this.$nextTick(() => {
            const scrollDiv = this.$refs.scrollDiv
            // 检查scrollDiv是否存在
            if (scrollDiv && scrollDiv.scrollHeight <= scrollDiv.clientHeight) {
              this.readed = true
            }
          })
        } else {
          if (this.interval != null) {
            this.counter = 0
            clearInterval(this.interval)
          }
        }
      }
    }
  },
  computed: {
    compiledMarkdown() {
      if (!this.privacyContent) return ''

      // 配置安全的marked选项
      marked.setOptions({
        breaks: true,
        gfm: true,
        headerIds: false,
        mangle: false,
        sanitize: false,
        smartLists: true,
        smartypants: true,
        xhtml: false
      })

      // 自定义渲染器，过滤危险内容
      const renderer = new marked.Renderer()

      // 重写链接渲染，过滤危险协议
      renderer.link = (href, title, text) => {
        if (href && typeof href === 'string') {
          const lowerHref = href.toLowerCase()
          if (lowerHref.startsWith('javascript:') ||
              lowerHref.startsWith('data:') ||
              lowerHref.startsWith('vbscript:')) {
            return `<span class="dangerous-link">${text}</span>`
          }
        }
        return `<a href="${href || '#'}" title="${title || ''}" target="_blank" rel="noopener noreferrer">${text}</a>`
      }

      // 重写图片渲染，过滤危险协议
      renderer.image = (href, title, text) => {
        if (href && typeof href === 'string') {
          const lowerHref = href.toLowerCase()
          if (lowerHref.startsWith('javascript:') ||
              lowerHref.startsWith('data:') ||
              lowerHref.startsWith('vbscript:')) {
            return `<span class="dangerous-image">[图片: ${text}]</span>`
          }
        }
        return `<img src="${href || ''}" alt="${text}" title="${title || ''}" />`
      }

      marked.use({ renderer })

      return marked(this.privacyContent)
    }
  },
  methods: {
    async getPrivacyContent() {
      try {
        const res = await getPrivacyStatement()
        if (res.success) {
          this.privacyContent = res.result.content || ''
        } else {
          this.privacyContent = this.globalDataArray.siteTemplateLanguage.privacy_statement_default || '开放原子大赛获奖队伍相关隐私声明内容'
        }
      } catch (error) {
        console.error('获取隐私声明失败:', error)
        this.privacyContent = this.globalDataArray.siteTemplateLanguage.privacy_statement_default || '开放原子大赛获奖队伍相关隐私声明内容'
      }
    },
    onChange(e) {
      this.checked = e.target.checked
    },

    agreeFun(res) {
      // 自定义事件，把res传给父组件,发射事件
      if (res == 2) {
        this.$emit('itemclick', res) // itemclick  为事件名
        this.$emit('update:privacyStatement', false)
      } else {
        if (this.checked) {
          this.$emit('itemclick', res) // itemclick  为事件名
          this.$emit('update:privacyStatement', false)
        } else {
          message.error(this.globalDataArray.siteTemplateLanguage.msg_no_read)
        }
      }
    },

    closePop() {
      this.$emit('update:privacyStatement', false)
      if (this.interval != null) {
        this.counter = 0
        clearInterval(this.interval)
      }
    },

    counterFun() {
      const that = this
      if (!that.checked) {
        that.counter = 1
        that.interval = setInterval(() => {
          that.counter--
          if (that.counter <= 0) {
            this.disabled = !this.disabled
            clearInterval(that.interval)
          }
        }, 1000)
      }
    },

    handleScroll() {
      if (typeof document === 'object') {
        const container = document.querySelector('.scrollable')
        if (container) {
          const { scrollTop, scrollHeight, clientHeight } = container
          if (scrollTop + clientHeight >= scrollHeight - 50) {
            this.readed = true
            if (this.theEnd) {
              this.theEnd = false
              message.success(this.globalDataArray.siteTemplateLanguage.to_the_end)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .pagePop .cont.txtCont {
  max-height: 36em;
}
.agreement {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid;
}
</style>
